exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-img[data-v-236ab950]{width:40px;height:40px;margin-right:5px;cursor:pointer;border-radius:5px}.row-img[data-v-236ab950]:last-child{margin-right:0px}.field-item[data-v-236ab950]{margin-bottom:5px}.preview-box[data-v-236ab950]{text-align:center}\n", ""]);

// exports
